import { Injectable } from '@angular/core';
import { SecureDataHttpService } from '@app/core/async-services/http/versioned/secure-data.http';
import { EncryptionService } from '../encryption/encryption.service';
import { API } from '@app/core/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SecureDataService {
  constructor(
    private _encryptionService: EncryptionService,
    private _secureDataHttpService: SecureDataHttpService,
  ) {}

  getTeamWellnessCheckInRisks(
    entId: string,
  ): Observable<API.GetWellnessRisksSuccess> {
    return this._encryptionService.secureApiCall((publicKey) =>
      this._secureDataHttpService.getTeamWellnessCheckInRisks(entId, publicKey),
    );
  }
}
